/* eslint-disable no-console */
import { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import PageLoader from "../../../components/PageLoader";
import ButtonCount from "../../../components/ButtonCount";
import useWindowSize from "../../../hooks/useWindow";
import { useWard } from "../../../context/GaurdianContext";
import Layout from "../../../components/Layout";

const STUDENT_SUBJECTS = "/api/v1/student/subjects";

const Student = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [studentSubject, setStudentSubject] = useState([]);
  const { getCurrentStudentId, selectedWard } = useWard();

  /**
   * Fetches all student subjects from the API and updates local state.
   */
  const getAllStudentSubject = () => {
    // Check if selectedWard is available
    if (!selectedWard) {
      console.log("No selected ward available yet");

      return;
    }

    const studentId = getCurrentStudentId();
    if (!studentId) {
      console.log("No student ID available");

      return;
    }

    setIsPageLoading(true);
    httprequest.get(`${STUDENT_SUBJECTS}?student_id=${studentId}`)
      .then((res) => {
        setIsPageLoading(false);
        setStudentSubject(res?.data?.data || []);
        setSearchResult(res?.data?.data || []);
      })
      .catch((err) => {
        setIsPageLoading(false);
        toast.error(err?.response?.message || "Failed to fetch subjects");
      });
  };

  // Fetch data when selectedWard becomes available
  useEffect(() => {
    if (selectedWard) {
      getAllStudentSubject();
    }
  }, [selectedWard]); // Add selectedWard as dependency

  const width = useWindowSize();
  const mobile = width < 600;

  const columns = [
    {
      name: "Subject Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Teacher Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Name</p>}
          {`${row?.teachers?.[0]?.first_name || "--/--"} ${
            row?.teachers?.[0]?.last_name || "--/--"
          }`}
        </>
      )
    },
    {
      name: "Teacher Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Email</p>}
          {row?.teachers?.[0]?.email || "--/--"}
        </>
      )
    },
    {
      name: "Teacher Contact",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Contact</p>}
          {row?.teachers?.[0]?.contact || "--/--"}
        </>
      )
    }
  ];

  const handleSubject = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const result = studentSubject?.filter((data) => valArray?.every(
      (word) => data?.name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.teachers?.[0]?.email?.toLowerCase().includes(word.toLowerCase()) ||
          data?.teachers?.[0]?.name?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // Add loading state for when selectedWard is not available yet
  if (!selectedWard) {
    return (
      <>
        <PageTitle
          title="Subject"
          subtitle="Loading ward information..."
        />
        <PageLoader />
        {/* <ToastContainer /> */}
      </>
    );
  }

  return (
    <Layout children={
      <>
        <PageTitle
          title="Subject"
          subtitle={`View all your Subject as for ${selectedWard.first_name} ${selectedWard.last_name}`}
        />
        {isPageLoading ? (
          <PageLoader />
        ) : (
          <div className="page-content">
            <div className="margin-bottom margin_tab">
              <ButtonCount
                count={studentSubject?.length}
                title="Number of Subjects"
              />
            </div>
            <Table
              data={searchResult}
              columns={columns}
              subHeader={true}
              pagination
              subHeaderComponent={
                studentSubject?.length > 0 && (
                  <TableSearch
                    placeholder="Search here..."
                    searchTableFunc={handleSubject}
                  />
                )
              }
            />
          </div>
        )}
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default Student;
